import React from "react";

const JcbIcon = () => (
  <svg
    width="25"
    height="20"
    viewBox="0 0 25 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0_1_3379)">
      <path
        d="M25 15.9008C25 18.1136 23.2579 19.9156 21.1186 19.9156H0V4.01475C0 1.80192 1.74209 0 3.88145 0H25V15.9008Z"
        fill="white"
      />
      <path
        d="M18.123 11.8228H19.7275C19.7734 11.8228 19.8804 11.8071 19.9263 11.8071C20.2319 11.7438 20.4917 11.4593 20.4917 11.0641C20.4917 10.6848 20.2319 10.4003 19.9263 10.3213C19.8804 10.3055 19.7888 10.3055 19.7276 10.3055H18.1231L18.123 11.8228Z"
        fill="url(#paint0_linear_1_3379)"
      />
      <path
        d="M19.5446 1.34343C18.0165 1.34343 16.7634 2.62384 16.7634 4.2202V7.20758H20.6907C20.7824 7.20758 20.8893 7.20757 20.9657 7.22333C21.852 7.27081 22.5092 7.74495 22.5092 8.56677C22.5092 9.21485 22.066 9.76808 21.2408 9.87879V9.9103C22.1424 9.97353 22.8301 10.4952 22.8301 11.3012C22.8301 12.1706 22.066 12.7396 21.0574 12.7396H16.7481V18.5879H20.8282C22.3563 18.5879 23.6095 17.3076 23.6095 15.7111V1.34343H19.5446Z"
        fill="#55B147"
      />
      <path
        d="M20.293 8.75656C20.293 8.37717 20.0332 8.12424 19.7275 8.07676C19.6971 8.07676 19.6206 8.061 19.5748 8.061H18.123V9.45191H19.5748C19.6207 9.45191 19.7123 9.45191 19.7276 9.43616C20.0333 9.38868 20.2931 9.13585 20.2931 8.75646"
        fill="url(#paint1_linear_1_3379)"
      />
      <path
        d="M4.17148 1.34343C2.64336 1.34343 1.39023 2.62383 1.39023 4.2202V11.3172C2.16963 11.7122 2.97949 11.9651 3.78945 11.9651C4.75215 11.9651 5.27168 11.3645 5.27168 10.5426V7.19171H7.65557V10.5268C7.65557 11.8228 6.87627 12.8819 4.23262 12.8819C2.62813 12.8819 1.375 12.5183 1.375 12.5183V18.572H5.45508C6.9832 18.572 8.23633 17.2917 8.23633 15.6952V1.34363L4.17148 1.34343Z"
        fill="#0D6DB5"
      />
      <path
        d="M11.8574 1.34343C10.3293 1.34343 9.07617 2.62383 9.07617 4.2202V7.98202C9.7792 7.36555 11.0017 6.9704 12.9729 7.06525C14.0273 7.11272 15.1581 7.41303 15.1581 7.41303V8.6301C14.5927 8.32979 13.9204 8.06101 13.0493 7.99777C11.5518 7.88717 10.6502 8.64585 10.6502 9.97353C10.6502 11.3171 11.5518 12.0758 13.0493 11.9493C13.9204 11.8861 14.5928 11.6016 15.1581 11.3171V12.5341C15.1581 12.5341 14.0426 12.8344 12.9729 12.8819C11.0017 12.9767 9.7792 12.5815 9.07627 11.9651V18.6036H13.1563C14.6845 18.6036 15.9375 17.3233 15.9375 15.7269V1.34363L11.8574 1.34343Z"
        fill="#E01D3B"
      />
    </g>
    <defs>
      <linearGradient
        id="paint0_linear_1_3379"
        x1="-118.138"
        y1="86.3623"
        x2="568.577"
        y2="86.3623"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#007940" />
        <stop offset="0.2285" stopColor="#00873F" />
        <stop offset="0.7433" stopColor="#40A737" />
        <stop offset="1" stopColor="#5CB531" />
      </linearGradient>
      <linearGradient
        id="paint1_linear_1_3379"
        x1="-118.158"
        y1="77.4089"
        x2="568.594"
        y2="77.4089"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#007940" />
        <stop offset="0.2285" stopColor="#00873F" />
        <stop offset="0.7433" stopColor="#40A737" />
        <stop offset="1" stopColor="#5CB531" />
      </linearGradient>
      <clipPath id="clip0_1_3379">
        <rect width="25" height="20" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

export default JcbIcon;
